import React from "react";
import { Box, ButtonGroup, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Custom styled Button for vertical tabs
 */
const VerticalTabButton = styled(Button)(({ theme, selected }) => ({
  width: "100%",
  textAlign: "left",
  justifyContent: "flex-start",
  padding: "12px 16px",
  borderRadius: 0,
  textTransform: "none",
  fontWeight: selected ? "bold" : "normal",
  color: selected ? "#c84653" : "#676767",
  backgroundColor: selected ? "rgba(200, 70, 83, 0.05)" : "transparent",
  borderLeft: selected ? "3px solid #c84653" : "3px solid transparent",
  "&:hover": {
    backgroundColor: selected
      ? "rgba(200, 70, 83, 0.08)"
      : "rgba(0, 0, 0, 0.04)",
  },
}));

/**
 * VerticalTabs component for selecting views in the admin panel
 */
const VerticalTabs = ({ tabs, activeTab, onChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        border: "1px solid #f0f0f0",
        borderRadius: "12px",
        overflow: "hidden",
        height: "100%",
        backgroundColor: "#fcfcfc",
      }}
    >
      <ButtonGroup orientation="vertical" variant="text" sx={{ width: "100%" }}>
        {tabs.map((tab, index) => (
          <VerticalTabButton
            key={tab.id}
            selected={activeTab === index}
            onClick={() => onChange(index)}
            startIcon={tab.icon}
            disableRipple
          >
            {tab.label}
          </VerticalTabButton>
        ))}
      </ButtonGroup>
    </Box>
  );
};

export default VerticalTabs;
